import React, {useContext} from 'react';
import { Row, Col } from 'react-flexbox-grid';
import styles from './styles.module.css';
import * as PATHS from '../../settings/paths';
import { Link } from 'react-router-dom';
import profile from './profile1.jpg';
import * as Icon from '../../components/Icons'
import { LanguageContext } from '../../context/Languages/LanguageProvider';

const Menu = () => {
  const { i18n } = useContext(LanguageContext);

    return (
        <div className={styles.menu}>
            <Row>
                <Col lg={8} xs={8}></Col>
                <Col lg={1} xs={2}>
                    <DropdownMenu component={'<img src="' + profile + '" width="24px" alt="" /> '} image={true}>
                        <DropdownMenuItem><Link to={PATHS.PROFILE} />{i18n.profile}</DropdownMenuItem>
                        <DropdownMenuItem><Link to={PATHS.CHANGE_PASSWORD} />{i18n.changePassword}</DropdownMenuItem>
                        <DropdownMenuItem><Link to={PATHS.BOOKINGS} />{i18n.bookings}</DropdownMenuItem>
                        <DropdownMenuItem><Link to={'/logout'} />{i18n.signOut}</DropdownMenuItem>
                    </DropdownMenu>
                </Col>
                <Col lg={1} xs={1}>
                    <DropdownMenu component={<Icon.Enİcon />} >
                        <DropdownMenuItem><Link to={'/#'} />{<Icon.Arİcon />}&nbsp;Arabic</DropdownMenuItem>
                    </DropdownMenu>
                </Col>
            </Row>

        </div>
    );
};
const DropdownMenu = ({ children, component, image }) => {
    return (
        <div className={styles.dropdown}>
            {image === true ?
                <div className={styles.label} dangerouslySetInnerHTML={{ __html: component }}></div>
                :
                <div className={styles.label}>{component}</div>
            }
            <ul className={styles.dropdownContent}>{children}</ul>
        </div>
    );
};

const DropdownMenuItem = ({ children }) => {
    return <li>{children}</li>;
};
export default Menu;